"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.useCue = void 0;
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var useCue = function (cue) {
    var videoService = (0, video_context_1.useVideo)();
    var setActive = React.useCallback(function setActive(active) {
        if (active) {
            videoService.send({ type: 'ACTIVATE_CUE', cue: cue });
        }
        else {
            videoService.send({ type: 'DEACTIVATE_CUE', cue: cue });
        }
    }, [cue, videoService]);
    React.useEffect(function () {
        var enterCue = function () {
            setActive(true);
        };
        var exitCue = function () {
            setActive(false);
        };
        cue.addEventListener('enter', enterCue);
        cue.addEventListener('exit', exitCue);
        return function () {
            cue.removeEventListener('enter', enterCue);
            cue.removeEventListener('exit', exitCue);
        };
    }, [cue, setActive]);
    return setActive;
};
exports.useCue = useCue;
